module.exports = __webpack_public_path__ + "img/wishlist-2.8a76ec8.webp";